<script>
    import { getContext } from 'svelte';
    import Router from 'svelte-spa-router'
    import {wrap} from 'svelte-spa-router/wrap'
    import { routedTabs } from './RoutedTabs.svelte';

    const { tabs, prefix } = getContext(routedTabs);

    $: routes = tabs.reduce((obj, tab) => ({
        ...obj,
        [tab.path]: wrap({component: tab.component, props: {...tab.props, prefix: tab.path}})
    }), {});

</script>

<div>
	<slot />
	<Router {routes} {prefix} />
</div>
